import { ELIGIBILITY_META } from "@/lib/constants";
import { CheckCircle, WarningCircle, XCircle } from "@phosphor-icons/react";

const ICONS = {
  eligible: CheckCircle,
  possibly_eligible: WarningCircle,
  not_eligible: XCircle,
};

export function EligibilityPill({ status, size = "sm" }) {
  const meta = ELIGIBILITY_META[status] || ELIGIBILITY_META.possibly_eligible;
  const Icon = ICONS[status] || WarningCircle;
  const pad = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2.5 py-1 text-xs";
  return (
    <span
      data-testid={`eligibility-pill-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-md border font-semibold ${meta.cls} ${pad}`}
    >
      <Icon weight="fill" className={size === "lg" ? "h-4 w-4" : "h-3.5 w-3.5"} />
      {meta.label}
    </span>
  );
}
